const defaultDate = { start_date: null, end_date: null };

class TransactionFilter { // eslint-disable-line fp/no-class
  accountData = null;

  accountLimit = null;

  filter = {
    ...defaultDate,
  };

  constructor(account, limit = null, { date = null }) { // eslint-disable-line max-params
    this.setAccount(account);
    this.setLimit(limit);
    this.setDate(date);
  }

  setAccount(data) {
    this.accountData = data;
  }

  account() {
    return this.accountData;
  }

  setLimit(data = null) {
    this.accountLimit = data;
  }

  limit() {
    return this.accountLimit;
  }

  setDate({ start = null, end = null }) {
    if (start === null || end === null) {
      this.filter = defaultDate;
      return;
    }

    this.filter = { start_date: start, end_date: end };
  }

  filters() {
    return {
      ...this.filter,
      limit: this.limit(),
    };
  }
}

export default TransactionFilter;
